import classNames from 'classnames';
import { FC } from 'react';

import { MobileAppsList, TMobileApp } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';

import styles from './MobileAppsBlock.styles.m.css';

interface IMobileAppsBlockProps {
  className?: string;
}

export const MobileAppsBlock: FC<IMobileAppsBlockProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const containerClassName = classNames(styles.container, className);

  return (
    <div className={containerClassName}>
      <div className={styles.divider}>
        <span className={styles.dividerText}>{t('deeplink_separator_download')}</span>
      </div>
      <MobileAppsList
        className={styles.list}
        apps={PROJECT_CONFIG.mobileApps as TMobileApp[]}
      />
    </div>
  );
};
